module.exports = "<h5 class=text-left><strong>{0}</strong> {1} </h5> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/services/notify/toast-templates/titled.html
// module id = 444
// module chunks = 0